module.exports = "/newsfeed/components/newsfeed-pages-route-f18a45.html";